<template style="height: 100%;">
    <div style="height: 100%;display: flex" id="homeBox">
        <el-row class="video-tree flex"  style="width: 100%;">

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <left-tree @showData="showData"  ref="tree" :isuseSearch="true"></left-tree>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%;min-width: 320px;width: 100%;flex: 1;">

                <div  style="display: flex">
                    <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>

                    <div class="df">
                        <div class="flex w66 alc">

                            <el-select v-model="i_rystate" size="mini" :placeholder="$t('personInformation_please_select_personnel_status_first')" @change="ryStateChange" filterable clearable
                                       style="width:100%; ">
                                <el-option v-for="item in i_rystateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                            </el-select>
                            <el-select v-model="i_rytype" size="mini" :placeholder="$t('personInformation_personnel_category')" @change="rytypeChange" filterable clearable style="width:100%; ">
                                <el-option v-for="item in i_rytypeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                            </el-select>
                            <el-input  class="marr4" style=""  v-model="vc_search" :placeholder="$t('personInformation_please_input')" clearable size="mini"></el-input>
                            <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
                            <el-button v-if="treeData&&treeData.isLeaf&&(i_hasAddEmployeeRight==1)"  size="mini" @click="detailFun({},'add')" :class="baseerp+'btn'">{{$t('personInformation_add_new')}}</el-button>
                        </div>
                    </div>
                </div>
                <el-table  class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                           :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                    <el-table-column :label="$t('personInformation_serial_no')" align="center" type="index" width="50px"></el-table-column>
                    <el-table-column prop="vc_username" :label="$t('personInformation_name')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_sex" :label="$t('personInformation_gender')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_rystate" :label="$t('personInformation_personnel_status')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_rytype" :label="$t('personInformation_personnel_category')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="dt_entry" :label="$t('personInformation_entry_date')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="dt_dimission" :label="$t('personInformation_resignation_date')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_dept" :label="$t('personInformation_department')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_gsname" :label="$t('personInformation_company')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_zw" :label="$t('personInformation_job_rank')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_station" :label="$t('personInformation_position')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="vc_zjnum" :label="$t('personInformation_id_number')" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="i_userid" :label="$t('personInformation_user_id')" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" :label="$t('personInformation_operation')">
                        <template slot-scope="scope">
                            <el-button  type="text" size="mini" @click="detailFun(scope.row,'edit')">{{$t('personInformation_details')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--        分页器-->
                <div class="block">
                    <div class="pages">
                        <div class="choosepage flexother mrt20 fl">
                            <el-pagination small @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="this.currentPage"
                                           :page-sizes="[20, 40, 60, 80]" :page-size="this.pageSize" layout="total,sizes" :total="this.total">
                            </el-pagination>
                            <el-pagination small :pager-count="5" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                           :current-page="this.currentPage" :page-size="this.pageSize" layout="prev, pager, next, jumper" :total="this.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div :class="baseerp+'div'">
                    <el-dialog :title="detailtitle" width="95%" top="30px" :visible.sync="dialogVisible"
                               :close-on-click-modal="false" @close="closeFun">
                        <detail-page :data="propData" v-if="dialogVisible" @close="closeFun"></detail-page>
                    </el-dialog>

                </div>


            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";

    // import tabTree from "./tabTree";
    import LeftTree from "./LeftTree";
    import DetailPage from "./DetailPage";
    export default {
        name: "workManage",
        components:{

            LeftTree,
            DetailPage

            // tabTree
        },
        data(){
            return{
                isright:true,//树显示按钮
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:20,//条
                total:0,//总数
                baseerp:'',//公共样式
                tableHeight:0,//列表高度
                detailtitle:'',
                dialogVisible:false,
                propData:{},
                treespan:4,
                rightspan:20,
                treeData:null,
                vc_search:'',
                i_rytypeList:[],
                i_rytype:'',
                i_rystateList:[{i_id:1,vc_name:this.$t('personInformation_on_the_job')},{i_id:-1,vc_name:this.$t('personInformation_resigned')},{i_id:2,vc_name:this.$t('personInformation_payroll_calculation')}],
                i_rystate:'',
                i_hasAddEmployeeRight:0,
            }
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();
            })
            // this.getUserList()
        },
        methods:{

            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            ...mapActions(["getCurrentMenuId"]),
            ryStateChange(){
                this.getUserTypeList();
                this.i_rytype='';
            },
            rytypeChange(){
                if(!this.i_rystate){
                    this.$message.error(this.$t('personInformation_please_select_personnel_status_first'));
                }
                //this.vc_rytype=this.i_rytypeList.find(i=>row.i_rytype==i.i_id).vc_name
            },
            async getUserTypeList(){
                let param={
                    vc_search:this.type_search,
                };
                let res=await API.getUserTypeList(param);
                if ( res.code == 1 ){
                    //this.i_rytypeList=res.data;
                    let list = [];
                        list = res.data.filter(item=>item.i_state==this.i_rystate)
                    this.i_rytypeList=this.i_rystate?list:res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            closeFun(type){
                this.dialogVisible=false
                if(type=='save'){
                    this.currentPage =1;
                    this.getUserList()
                }
            },
            //新增 编辑
            detailFun(val,type){
                if(type=='add'){
                    this.detailtitle=this.$t('personInformation_entry_registration');
                    this.dialogVisible=true;
                    this.propData={
                        type:type,
                        val:this.treeData,

                    }
                }else{
                    this.detailtitle=this.$t('personInformation_personnel_information');
                    this.dialogVisible=true;
                    this.propData={
                        type:type,
                        val:val
                    }
                }

            },
            showData(val){
                this.treeData=val;
                this.currentPage =1;
                this.getUserList();
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getUserList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getUserList()
            },
            searchFun(){
                this.currentPage=1
                this.getUserList()
            },
            async getUserList() {
                let params = {
                    i_dept:this.treeData.i_id,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.vc_search,
                    i_rytype:this.i_rytype,
                    i_rystate:this.i_rystate,
                };
                let res = await API.getUserList(params);
                if (res.code == 1) {
                    this.tableData=res.data.userList;
                    this.total=res.data.total;
                    this.i_hasAddEmployeeRight=res.data.i_hasAddEmployeeRight
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .df{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .row-expand-cover .el-table__expand-icon {
            visibility: hidden;
        }
        .el-table--enable-row-transition{
            /*min-width: 64.286rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            /*margin-right: 10px;*/
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
    /deep/{
        .el-dialog{
            min-width: 900px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table__expanded-cell[class*=cell]{
            padding: 5px;
        }
        .dtj{
            color: #409EFF;
        }
        .tg{
            color: #03cb45;
        }
        .spz{
            color: #ffbe06;
        }
        .wtg{
            color: #ff0500;
        }
        .yzf{
            color: #878787;
        }
    }

</style>